import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import Products from './pages/product/Products';
import Shop from './pages/Shop';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Layout from './components/Layout';
import ProductDetail from './pages/product/ProductDetail';
import Cart from './pages/Cart';
import Register from './pages/auth/Register';
import Login from './pages/auth/Login';
import Dashboard from './pages/user/Dashboard';
import LayoutUser from './components/user/LayoutUser';
import Error401 from './pages/errors/Error401';
import Error500 from './pages/errors/Error500';
import Error404 from './pages/errors/Error404';
import Orders from './pages/user/order/Orders';
import OrderDetail from './pages/user/order/OrderDetail';
import EditPassword from './components/user/EditPassword';
import UpdateProfile from './pages/user/UpdateProfile';
import Checkout from './pages/Checkout';


export const LOGIN_ROUTE = '/login'

const Routes = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path:"/",
        element : <Home />
      },
      {
        path:"/products",
        element : <Products />
      },
      {
        path: "/product/:id", 
        element: <ProductDetail />
      },
      {
        path:"/shop",
        element : <Shop />
      },
      {
        path:"/contact-us",
        element : <ContactUs />
      },
      {
        path:"/abous-us",
        element : <AboutUs />
      },
      {
        path:"/cart",
        element : <Cart />
      },
      {
        path:"/register",
        element : <Register />
      },
      {
        path:LOGIN_ROUTE,
        element : <Login />
      },
      {
        path:"*",
        element : <Error404 />
      },
      {
        path:"/404",
        element : <Error404 />
      },
      {
        path:"/500",
        element : <Error500 />
      },
      {
        path:"/401",
        element : <Error401 />
      },
      {
        path:"/checkout",
        element : <Checkout />
      }

    ]
  },
  {
    element : <LayoutUser />,
    children: [ 
      {
        path:"/user/dashboard",
        element : <Dashboard />
      },
      {
        path:"/user/orders",
        element : <Orders />
      },
      {
        path:"/user/orders/:id",
        element : <OrderDetail />
      },
      {
        path:"/user/editPassword",
        element : <EditPassword />
      },
      {
        path:"/user/editProfile",
        element : <UpdateProfile />
      }
    ]
  }
  
])

export default Routes;